import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { IoChevronBack } from 'react-icons/io5';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import Spinner from '../../components/common/Spinner';

const FALLBACK = `제1조 (목적)
본 약관은 (주)조군산업(이하 "회사")이 제공하는 렉스크리트 비즈니스 관리 서비스(이하 "서비스")의 이용에 관한 조건 및 절차, 회사와 이용자의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.

제2조 (정의)
• "서비스"란 회사가 제공하는 일정 관리, 자재 주문, 업체 간 소통 등 업무 관리 플랫폼을 말합니다.
• "이용자"란 본 약관에 따라 서비스를 이용하는 회원을 말합니다.
• "회원"이란 서비스에 가입하여 회사가 승인한 자를 말합니다.

제3조 (약관의 효력 및 변경)
본 약관은 서비스를 이용하고자 하는 모든 이용자에게 적용됩니다. 회사는 필요한 경우 약관을 변경할 수 있으며, 변경 시 시행일 7일 전부터 서비스 내에서 공지합니다.

제4조 (회원 가입)
서비스 이용을 원하는 자는 회사가 정한 양식에 따라 회원 정보를 기입하고 본 약관에 동의한 후 가입 신청을 합니다. 회사는 심사 후 가입을 승인합니다.

제5조 (서비스 이용)
• 서비스는 회사의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간 제공됩니다.
• 회사는 서비스 개선을 위해 사전 공지 후 일시적으로 서비스를 중단할 수 있습니다.

제6조 (이용자의 의무)
• 이용자는 타인의 정보를 도용하거나 허위 정보를 등록해서는 안 됩니다.
• 이용자는 서비스를 이용하여 법령 또는 공공질서에 위반되는 행위를 해서는 안 됩니다.
• 이용자는 자신의 계정 정보를 안전하게 관리할 책임이 있습니다.

제7조 (회사의 의무)
회사는 관련 법령과 본 약관이 금지하는 행위를 하지 않으며, 안정적인 서비스 제공을 위해 최선을 다합니다.

제8조 (면책)
회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우 책임이 면제됩니다.

부칙
본 약관은 2026년 2월 24일부터 시행합니다.`;

const TermsPage = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const snap = await getDoc(doc(db, 'policies', 'terms'));
        setContent(snap.exists() ? snap.data().content : FALLBACK);
      } catch {
        setContent(FALLBACK);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <Container>
      <Header>
        <BackBtn onClick={() => navigate(-1)}><IoChevronBack size={22} /></BackBtn>
        <Title>이용약관</Title>
        <Spacer />
      </Header>
      <Content>
        {loading ? <Spinner variant="dots" size="md" fullPage /> : <PolicyText>{content}</PolicyText>}
      </Content>
    </Container>
  );
};

export default TermsPage;

const Container = styled.div`min-height: 100vh; background: #F4F3F8;`;
const Header = styled.div`display: flex; align-items: center; justify-content: space-between; padding: 16px 16px 14px; background: white; border-bottom: 1px solid #EEEEF0;`;
const BackBtn = styled.button`display: flex; padding: 4px; color: #2C3640;`;
const Title = styled.p`font-size: 16px; font-weight: 700; color: #1E2A32;`;
const Spacer = styled.div`width: 30px;`;
const Content = styled.div`padding: 20px 20px 60px;`;
const PolicyText = styled.div`font-size: 14px; color: #5A6B75; line-height: 1.8; white-space: pre-line;`;
